/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Us_EnglishInputs */

const en_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US English`)
};

const fr_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anglais américain`)
};

const de_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US-Englisch`)
};

const it_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglese americano`)
};

const ru_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Американский английский`)
};

const es_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglés de EE. UU.`)
};

const zh_cn2_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美国英语`)
};

const ja_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アメリカ英語`)
};

const hi_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अमेरिकी अंग्रेजी`)
};

const pt_pt2_us_english = /** @type {(inputs: Us_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglês americano`)
};

/**
* | output |
* | --- |
* | "US English" |
*
* @param {Us_EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const us_english = /** @type {((inputs?: Us_EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Us_EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_us_english(inputs)
	if (locale === "de") return de_us_english(inputs)
	if (locale === "it") return it_us_english(inputs)
	if (locale === "ru") return ru_us_english(inputs)
	if (locale === "es") return es_us_english(inputs)
	if (locale === "zh-CN") return zh_cn2_us_english(inputs)
	if (locale === "ja") return ja_us_english(inputs)
	if (locale === "hi") return hi_us_english(inputs)
	if (locale === "pt-PT") return pt_pt2_us_english(inputs)
	return en_us_english(inputs)
});